import { css } from '@emotion/react'

const emoji = theme => css`
  font-size: ${theme.fontSize.x4large};
`

export const styles = {
  emoji,
}
